/** Custom event raised when a new container is tracked */
export const TRACK_CONTAINER_EVENT_NAME = 'trackcontainer';
/** Browser events that signal user activity */
export const browserActivityEvents = [
    'mousemove',
    'keydown',
    'wheel',
    'mousedown',
    'touchstart',
    'touchmove',
    'visibilitychange',
    TRACK_CONTAINER_EVENT_NAME,
];
//# sourceMappingURL=constants.js.map